/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type EmailActivationPageActivationMutationVariables = {
    token: string;
};
export type EmailActivationPageActivationMutationResponse = {
    readonly userActivation: {
        readonly user: {
            readonly id: string;
            readonly username: string;
        };
    };
};
export type EmailActivationPageActivationMutation = {
    readonly response: EmailActivationPageActivationMutationResponse;
    readonly variables: EmailActivationPageActivationMutationVariables;
};



/*
mutation EmailActivationPageActivationMutation(
  $token: String!
) {
  userActivation(input: {token: $token}) {
    user {
      id
      username
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UserActivationPayload",
    "kind": "LinkedField",
    "name": "userActivation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailActivationPageActivationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailActivationPageActivationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de575cca80f618078725166b07d322ee",
    "id": null,
    "metadata": {},
    "name": "EmailActivationPageActivationMutation",
    "operationKind": "mutation",
    "text": "mutation EmailActivationPageActivationMutation(\n  $token: String!\n) {\n  userActivation(input: {token: $token}) {\n    user {\n      id\n      username\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '99a85357cb39a90bd9a3b18c5e69deec';
export default node;
